import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import useManagementDashboard from '../../management/dashboard/useManagementDashboard';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import SessionContext from '../../../library/Core/SessionContext';
//import { DomainElement } from '../../../library/Core/SmartTypes';

interface DomainElement {
    name: string;
    // Define other properties if needed
}
const LeadInfo: React.FC = () => {
//variable initialization
    const [programId, setProgramId] = useState<string | null>(null);
    const [instituteList, setInstituteList] = useState<DomainElement[]>([]);
    const [preferredCampuses, setPreferredCampuses] = useState<string[]>([]);
    const [selectedInstitute, setSelectedInstitute] = useState<string[]>(['']); // Array to store selected program
    const [instituteError, setInstituteError] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [gender, setGender] = useState<string>('');
    const [registrationBy, setRegistrationBy] = useState<string>('');
    const [registrationByError, setRegistrationByError] = useState<string>('');
    const [lastNameError, setLastNameError] = useState<string>('');
    const [firstNameError, setFirstNameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [phoneNumberError, setPhoneNumberError] = useState<string>('');
    const [genderError, setGenderError] = useState<string>('');
    const [countryCode, setCountryCode] = useState<string>(''); 
    const [countryCodeError, setCountryCodeError] = useState<string>('');
    const [inames, setInames] = useState<string[]>([]);
    const [iids, setIids] = useState<number[]>([]);
    const currentTime = new Date();
    let sesinstituteId = useState<string>(''); 
    let userId = useState<string>('');
   //// const [instituteList, setInstituteList] = useState<DomainElement[]>([]);
    const { globalState } = useContext(GlobalContext);
    const [campusData, setCampusData] = useState<{ name: string }[]>([]);
  //  const [instituteList, setinstituteList] = useState(getinstituteList('INSTITUTE_GROUP_CODE', campuses));
    //alert(instituteList);
   // console.log(instituteList);
   const urlParams = new URLSearchParams(window.location.search);
   const id: any = urlParams.get('id');
    const { sessionState } = useContext(SessionContext);
   
    let [institutes, setInstitutes] = useState<string[]>([]);
  ;

    useEffect(() => {
      if (sessionState && sessionState.institutes) {
        setInstitutes(sessionState.institutes);
      }
    }, [sessionState]);
 



    let school_settings:any = JSON.parse(localStorage.getItem('school_settings') ?? '{}');      
    console.log(school_settings)  
       
    const userDataString = sessionStorage.getItem('user');
     if (!userDataString) {
        //window.location.href = "/404";
    }
   // alert(userDataString)
    if (userDataString) {
        // Parse JSON string to object
        const userData = JSON.parse(userDataString);
        sesinstituteId = userData.institutes; 
        userId = userData.userId;       
    }
  //  console.log('userid',userId);
    // Event handler to handle changes in the inputs
    const handleCountryCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //const selectedCountryCode = e.target.value;
        setCountryCode(e.target.value);
       // setCountryCode(selectedCountryCode);
        setCountryCodeError('');
    }
    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value);
        setFirstNameError('');
    };

    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value);
        setLastNameError('');
    };
  
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setEmailError('');
    };

    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhoneNumber(e.target.value);
        setPhoneNumberError('');
    };

    const handleGenderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGender(e.target.value);
        setGenderError('');
    };

    const handleRegisterationByChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRegistrationBy(e.target.value);
        setRegistrationByError('');
    };

    const validateFields = () => {//validation
       
        const filteredInstitute = selectedInstitute.filter(institute => institute !== '' && selectedInstitute.length > 1);
        let isValid = true;
        if (typeof firstName !== 'string' || !/^[a-zA-Z]+$/.test(firstName.trim()) || firstName.length > 15) {
            setFirstNameError('First name must be a non-empty string containing only letters with a length between 1 and 15 characters');
            isValid = false;
        }
        if (typeof lastName !== 'string' || !/^[a-zA-Z]+$/.test(lastName.trim()) || lastName.length > 15) {
            setLastNameError('Last name must be a non-empty string containing only letters with a length between 1 and 15 characters');
            isValid = false;
        }
        
        return isValid;
    };

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const isValidPhoneNumber = (phoneNumber: string) => {
        return /^\d+$/.test(phoneNumber);
    };
    useEffect(() => {
        const fetchLeadInfo = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_LEAD_SERVER}/addlead/getsinglelead`, {
                    id: id,
                });
                const leadData = response.data.data[0]; // Assuming data contains only one lead
                setFirstName(leadData.first_name);
                setLastName(leadData.last_name);
                setEmail(leadData.email);
                setPhoneNumber(leadData.mobile);
                setGender(leadData.gender);
                setRegistrationBy(leadData.registration_by);
                const emailId = leadData.email;
                const Leadid= leadData.id;
                setProgramId(leadData.program);
               // alert(leadData.program);
               // alert(leadData.gender);
                 setCountryCode(leadData.country_code); // Set the country code from API
                const campusResponse = await axios.post(`${process.env.REACT_APP_LEAD_SERVER}/addlead/getinstitutebyid`, { id: id});
                const campusData = campusResponse.data.data;
                setCampusData(campusData); // Set campusData state
            } catch (error) {
                console.error('Error while fetching lead info:', error);
            }
        };

        fetchLeadInfo();
    }, []);

    const instituteToFilter = selectedInstitute.slice(1);
    const handleSubmit = () => {//Submit action
     //   alert('hi');
        if (validateFields()) {
            const saveLeadInfo = async () => {
                try {
                    const response = await axios.post<{ success: boolean, message: string, insertedIds: number }>(`${process.env.REACT_APP_LEAD_SERVER}/addlead/updatepersonalinfo`, {
                        first_name: firstName,
                        last_name:lastName,
                        registrationBy:registrationBy,
                        gender,
                        updated_on:currentTime,
                        email
                    });
                    
                    if (response.data.success) {                        
                        // Redirect to the next page\
                       // alert(programId)
                        if (programId=== null) { // Check if programId is not null
                            window.location.href = "/lead/update-lead-program?id="+id;// Redirect to the next page
                        }else{
                          window.location.href = `/lead/update-target-program?id=`+id; 
                        }
                      //  <Link to="/lead/add-target-program">Go to Target Program</Link>
                    } else {
                        console.error('Failed to save lead personal info:', response.data.message);
                    }
                    
                } catch (error) {
                    console.error('Error while saving lead personal info:', error);
                }
            };

            saveLeadInfo();
        }
    };
    useEffect(() => {
         fetchInstitute();
       
    }, []);
    // Function to fetch programs from API

    const fetchInstitute = async () => {
        try {
        
         //  let instituteString = instituteId.join(', ');
           
    // alert(instituteString);  
     //const instituteString = institutes.join(', '); // Convert array to string
   //  alert(sesinstituteId);
     let requestBody = { instituteId:sesinstituteId };
     console.log('pass id',requestBody);
      // const requestBody = { institutes }; // Construct the request body
      
        const response = await axios.post(`${process.env.REACT_APP_LEAD_SERVER}/addlead/getinstitute`, requestBody);
        const data = response.data;
            if (data.success) {
                // Update component state with fetched programs
                setInames(data.names);
                setIids(data.id);
               // alert(data.names); 
            } else {
                console.error('Failed to fetch institute:', data.message);
            }
        } catch (error) {
            console.error('An error occurred while fetching institute:', error);
        }
    };
 
    // Function to generate options for program dropdown
// Ensure that generateInstituteCheckboxes doesn't expect any arguments
const generateInstituteCheckboxes = (): JSX.Element[] => {
    return iids.map((iid, index) => {
        const instituteName = inames[index];
        const isChecked = campusData.some((campus: { name: string }) => campus.name === instituteName);

        return (
            <div key={iid} className="col-auto">
                <div className='form-check'>
                    <input

                         disabled

                        className="form-check-input"
                        type="checkbox"
                        name="institute"
                        id={`institute-${iid}`}
                        value={iid.toString()}
                        checked={isChecked}
                        onChange={(e) => handleInstituteCheckboxChange(e, iid)}
                    />
                    <label className="form-check-label" htmlFor={`program-${iid}`}>
                        {instituteName}
                    </label>
                </div>
            </div>
        );
    });
};

    
    



    // Event handler for program checkbox change
    const handleInstituteCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            // Add the selected program ID to the list
            setSelectedInstitute([...selectedInstitute, id.toString()]); // Convert id to string
        } else {
            // Remove the selected program ID from the list
            setSelectedInstitute(selectedInstitute.filter(instituteId => instituteId !== iids.toString())); // Convert id to string
        }
        setInstituteError('');
    };
 




    return (
        <div className="main flex-1 bg-white">
            <section className="alumni_directory_details container-fluid">
                <div className="max-1140 pt-3 pt-sm-5 px-lg-0 pb-5 overflow-hidden mx-auto">
                    <div className="m-w-90 d-flex justify-content-between align-items-center mb-3">
                        <h3 data-aos="fade-left" data-aos-delay="600" className="font-35 font-600 mb-0 block-title aos-init aos-animate">
                            Update Lead
                        </h3>
                       
                    </div>

                    <div className="job_internship_tab polartabsec radius-6 mx-auto">
                        <div className="xscroll p-0">
                        <ul className="nav nav-tabs" id="JobInternshipTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="personal-info-tab" data-bs-toggle="tab" data-bs-target="#personal-info" type="button" role="tab" aria-controls="personal-info" aria-selected="true">Personal Info</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                <button className="nav-link" id="personal-info-tab" data-bs-toggle="tab" data-bs-target="#personal-info" type="button" role="tab" aria-controls="personal-info" aria-selected="true" disabled>Target Program</button>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                    {/* tab buttons ends here */}

                    <div className="row m-0 pt-4 mt-2 JobInternshipListing">
                        <div className="flex-1 polarcontsec tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="personal-info" role="tabpanel" aria-labelledby="personal-info-tab">
                                <form className="lstCustForm w-100 formrowpx mt-2 max-700 mx-auto">
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <label className="form-label m-0 mb-1 font-18 font-500 w-100">Registration By</label>
                                            <div className="row g-2">
                                                <div className="col-sm-12">
                                                    <hr className="my-1"/>
                                                </div>
                                                <div className="col-auto">
                                <div className="d-flex flex-wrap justify-content-start align-items-center pe-5">
                                    <input type="radio" name="registrationBy" id="Registration_Self" className="form-check-input custom-border-84-20 m-0" value="Self" checked={registrationBy === 'Self'} onChange={handleRegisterationByChange}/>
                                    <label className="form-check-label font-16 font-500 ms-2">Self</label>
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="d-flex flex-wrap justify-content-start align-items-center pe-5">
                                    <input type="radio" name="registrationBy" id="Registration_Guardian" className="form-check-input custom-border-84-20 m-0" value="Guardian" checked={registrationBy === 'Guardian'} onChange={handleRegisterationByChange}/>
                                    <label className="form-check-label font-16 font-500 ms-2">Guardian</label>
                                </div>
                            </div>
                                               
                                                <div className="col-sm-12">
                                                    <hr className="my-1"/>
                                                </div>
                                                {registrationByError && <div className="text-danger">{registrationByError}</div>}
                                            </div>
                                        </div>
                    <div className="col-md-12">
                        <label className="form-label m-0 mb-1 font-18 font-500 w-100" htmlFor="OfficialnameofInstitute">Institute</label>
                            <div className="row g-2">
                                <div className="col-12">
                                    <div className="row g-2 g-sm-3 g-md-4">
                                    {generateInstituteCheckboxes()}
                                    </div>
                                {instituteError && <div className="text-danger">{instituteError}</div>}
                            </div>
                        </div>
                    </div>
                       
                  


                                        <div className="col-md-12">
                                            <label className="form-label m-0 mb-1 font-18 font-500 w-100">Lead Name</label>
                                            <div className="row g-4">
                                                <div className="col-md-6">
                                                    <input
                                                        type="text"
                                                        className="form-control flex-1"
                                                        placeholder="First Name"
                                                        id="firstName"
                                                        value={firstName}
                                                        onChange={handleFirstNameChange}
                                                    />
                                                     {firstNameError && <div className="text-danger">{firstNameError}</div>}
                                                  
                                                </div>
                                                <div className="col-md-6">
                                                    <input
                                                     type="text" 
                                                     className="form-control flex-1" 
                                                     placeholder="Last Name"
                                                      id="lastName" 
                                                      value={lastName} 
                                                       onChange={handleLastNameChange}/>
 {lastNameError && <div className="text-danger">{lastNameError}</div>}
                                                       
                                                    
                                                </div>
                                               
                                            </div>
                                        </div>
                                      
                                        <div className="col-md-6">
                                            <label className="form-label m-0 mb-1 font-18 font-500 w-100" >Contact Email</label>
                                            <input
                                                type="email"
                                                disabled
                                                className="form-control flex-1"
                                                placeholder="Ex: abc@xyz.com"
                                                id="email"
                                                value={email}
                                                onChange={handleEmailChange}
                                            />
                                             {emailError && <div className="text-danger">{emailError}</div>}
                                        </div>
                                      
                                        <div className="col-md-6">
                                            <label className="form-label m-0 mb-1 font-18 font-500 w-100">Mobile number (with country code)</label>
                                            <div className="row g-2">
                                                <div className="col-auto">
                                                <select
                id="mobileCountryCode"
                name="countryCode"
                disabled
                value={countryCode}
                onChange={handleCountryCodeChange}
                className="form-select form-control country-code"
            >
                                                        <optgroup label="Top Countries">
                                                            <option value="">Select </option>
                                                            <option value="India (+91)">India (+91) </option>
                                                            <option value="United Kingdom (+44)">United Kingdom (+44) </option>
                                                            <option value="Canada (+1)">Canada (+1) </option><option value="Australia (+61)">Australia (+61) </option><option value="Germany (+49)">Germany (+49) </option><option value="Russian Federation (+7)">Russian Federation (+7) </option><option value="China (+86)">China (+86) </option><option value="Singapore (+65)">Singapore (+65) </option><option value="United Arab Emirates (+971)">United Arab Emirates (+971) </option><option value="Japan (+81)">Japan (+81) </option></optgroup><optgroup label="----------------------"><option value="Afghanistan (+93)">Afghanistan (+93) </option><option value="Algeria (+213)">Algeria (+213) </option><option value="Andorra (+376)">Andorra (+376) </option><option value="Anguilla (+1264)">Anguilla (+1264) </option><option value="Antigua and Barbuda (+1268)">Antigua and Barbuda (+1268) </option><option value="Argentina (+54)">Argentina (+54) </option><option value="Armenia (+374)">Armenia (+374) </option><option value="Aruba (+297)">Aruba (+297) </option><option value="Austria (+43)">Austria (+43) </option><option value="Azerbaijan (+994)">Azerbaijan (+994) </option><option value="Bahamas (+1242)">Bahamas (+1242) </option><option value="Bahrain (+973)">Bahrain (+973) </option><option value="Bangladesh (+880)">Bangladesh (+880) </option><option value="Barbados (+1246)">Barbados (+1246) </option><option value="Belarus (+375)">Belarus (+375) </option><option value="Belgium (+32)">Belgium (+32) </option><option value="Belize (+501)">Belize (+501) </option><option value="Benin (+229)">Benin (+229) </option><option value="Bermuda (+1441)">Bermuda (+1441) </option><option value="Bhutan (+975)">Bhutan (+975) </option><option value="Bolivia (+591)">Bolivia (+591) </option><option value="Bosnia and Herzegovina (+387)">Bosnia and Herzegovina (+387) </option><option value="Botswana (+267)">Botswana (+267) </option><option value="Brazil (+55)">Brazil (+55) </option><option value="British Indian Ocean Territory (+246)">British Indian Ocean Territory (+246) </option><option value="Brunei Darussalam (+673)">Brunei Darussalam (+673) </option><option value="Bulgaria (+359)">Bulgaria (+359) </option><option value="Burkina Faso (+226)">Burkina Faso (+226) </option><option value="Burma (Myanmar) (+95)">Burma (Myanmar) (+95) </option><option value="Burundi (+257)">Burundi (+257) </option><option value="Cambodia (+855)">Cambodia (+855) </option><option value="Cameroon (+237)">Cameroon (+237) </option><option value="Cape Verde (+238)">Cape Verde (+238) </option><option value="Cayman Islands (+1345)">Cayman Islands (+1345) </option><option value="Central African Republic (+236)">Central African Republic (+236) </option><option value="Chad (+235)">Chad (+235) </option><option value="Chile (+56)">Chile (+56) </option><option value="Colombia (+57)">Colombia (+57) </option><option value="Comoros (+269)">Comoros (+269) </option><option value="Congo (+242)">Congo (+242) </option><option value="Cook Islands (+682)">Cook Islands (+682) </option><option value="Costa Rica (+506)">Costa Rica (+506) </option><option value="Cote D`Ivoire (Ivory Coast) (+225)">Cote D`Ivoire (Ivory Coast) (+225) </option><option value="Croatia (+385)">Croatia (+385) </option><option value="Cuba (+53)">Cuba (+53) </option><option value="Cyprus (+357)">Cyprus (+357) </option><option value="Czech Republic (+420)">Czech Republic (+420) </option><option value="Denmark (+45)">Denmark (+45) </option><option value="Djibouti (+253)">Djibouti (+253) </option><option value="Dominica (+1767)">Dominica (+1767) </option><option value="Dominican Republic (+1809)">Dominican Republic (+1809) </option><option value="East Timor (+670)">East Timor (+670) </option><option value="Ecuador (+593)">Ecuador (+593) </option><option value="Egypt (+20)">Egypt (+20) </option><option value="El Salvador (+503)">El Salvador (+503) </option><option value="Equatorial Guinea (+240)">Equatorial Guinea (+240) </option><option value="Eritrea (+291)">Eritrea (+291) </option><option value="Estonia (+372)">Estonia (+372) </option><option value="Ethiopia (+251)">Ethiopia (+251) </option><option value="Falkland Islands (Malvinas) (+500)">Falkland Islands (Malvinas) (+500) </option><option value="Faroe Islands (+298)">Faroe Islands (+298) </option><option value="Fiji (+679)">Fiji (+679) </option><option value="Finland (+358)">Finland (+358) </option><option value="France (+33)">France (+33) </option><option value="French Guiana (+594)">French Guiana (+594) </option><option value="French Polynesia (+689)">French Polynesia (+689) </option><option value="Gabon (+241)">Gabon (+241) </option><option value="Gambia (+220)">Gambia (+220) </option><option value="Georgia (+995)">Georgia (+995) </option><option value="Ghana (+233)">Ghana (+233) </option><option value="Gibraltar (+350)">Gibraltar (+350) </option><option value="Greece (+30)">Greece (+30) </option><option value="Greenland (+299)">Greenland (+299) </option><option value="Grenada (+1473)">Grenada (+1473) </option><option value="Guadeloupe (+590)">Guadeloupe (+590) </option><option value="Guam (+1671)">Guam (+1671) </option><option value="Guatemala (+502)">Guatemala (+502) </option><option value="Guinea (+224)">Guinea (+224) </option><option value="Guinea-Bissau (+245)">Guinea-Bissau (+245) </option><option value="Guyana (+592)">Guyana (+592) </option><option value="Haiti (+509)">Haiti (+509) </option><option value="Honduras (+504)">Honduras (+504) </option><option value="Hong Kong (+852)">Hong Kong (+852) </option><option value="Hungary (+36)">Hungary (+36) </option><option value="Iceland (+354)">Iceland (+354) </option><option value="Indonesia (+62)">Indonesia (+62) </option><option value="Iran (+98)">Iran (+98) </option><option value="Iraq (+964)">Iraq (+964) </option><option value="Ireland (+353)">Ireland (+353) </option><option value="Israel (+972)">Israel (+972) </option><option value="Italy (+39)">Italy (+39) </option><option value="Jamaica (+1876)">Jamaica (+1876) </option><option value="Jordan (+962)">Jordan (+962) </option><option value="Kenya (+254)">Kenya (+254) </option><option value="Kiribati (+686)">Kiribati (+686) </option><option value="Korea (North) (+850)">Korea (North) (+850) </option><option value="Korea (South) (+82)">Korea (South) (+82) </option><option value="Kuwait (+965)">Kuwait (+965) </option><option value="Kyrgyzstan (+996)">Kyrgyzstan (+996) </option><option value="Laos (+856)">Laos (+856) </option><option value="Latvia (+371)">Latvia (+371) </option><option value="Lebanon (+961)">Lebanon (+961) </option><option value="Lesotho (+266)">Lesotho (+266) </option><option value="Liberia (+231)">Liberia (+231) </option><option value="Libya (+218)">Libya (+218) </option><option value="Liechtenstein (+423)">Liechtenstein (+423) </option><option value="Lithuania (+370)">Lithuania (+370) </option><option value="Luxembourg (+352)">Luxembourg (+352) </option><option value="Macau (+853)">Macau (+853) </option><option value="Macedonia (+389)">Macedonia (+389) </option><option value="Madagascar (+261)">Madagascar (+261) </option><option value="Malawi (+265)">Malawi (+265) </option><option value="Malaysia (+60)">Malaysia (+60) </option><option value="Maldives (+960)">Maldives (+960) </option><option value="Mali (+223)">Mali (+223) </option><option value="Malta (+356)">Malta (+356) </option><option value="Marshall Islands (+692)">Marshall Islands (+692) </option><option value="Martinique (+596)">Martinique (+596) </option><option value="Mauritania (+222)">Mauritania (+222) </option><option value="Mauritius (+230)">Mauritius (+230) </option><option value="Mexico (+52)">Mexico (+52) </option><option value="Micronesia (+691)">Micronesia (+691) </option><option value="Moldova (+373)">Moldova (+373) </option><option value="Monaco (+377)">Monaco (+377) </option><option value="Mongolia (+976)">Mongolia (+976) </option><option value="Montserrat (+1664)">Montserrat (+1664) </option><option value="Mozambique (+258)">Mozambique (+258) </option><option value="Namibia (+264)">Namibia (+264) </option><option value="Nauru (+674)">Nauru (+674) </option><option value="Nepal (+977)">Nepal (+977) </option><option value="Netherlands (+31)">Netherlands (+31) </option><option value="Netherlands Antilles (+599)">Netherlands Antilles (+599) </option><option value="New Caledonia (+687)">New Caledonia (+687) </option><option value="New Zealand (+64)">New Zealand (+64) </option><option value="Nicaragua (+505)">Nicaragua (+505) </option><option value="Niger (+227)">Niger (+227) </option><option value="Norfolk Island (+672)">Norfolk Island (+672) </option><option value="Northern Mariana Islands (+1670)">Northern Mariana Islands (+1670) </option><option value="Norway (+47)">Norway (+47) </option><option value="Oman (+968)">Oman (+968) </option><option value="Other (+0000)">Other (+0000) </option><option value="Pakistan (+92)">Pakistan (+92) </option><option value="Palau (+680)">Palau (+680) </option><option value="Panama (+507)">Panama (+507) </option><option value="Papua New Guinea (+675)">Papua New Guinea (+675) </option><option value="Paraguay (+595)">Paraguay (+595) </option><option value="Peru (+51)">Peru (+51) </option><option value="Philippines (+63)">Philippines (+63) </option><option value="Pitcairn (+870)">Pitcairn (+870) </option><option value="Poland (+48)">Poland (+48) </option><option value="Portugal (+351)">Portugal (+351) </option><option value="Qatar (+974)">Qatar (+974) </option><option value="Reunion (+262)">Reunion (+262) </option><option value="Romania (+40)">Romania (+40) </option><option value="Rwanda (+250)">Rwanda (+250) </option><option value="Saint Lucia (+1758)">Saint Lucia (+1758) </option><option value="Saint Vincent and the Grenadines (+1784)">Saint Vincent and the Grenadines (+1784) </option><option value="Samoa (+685)">Samoa (+685) </option><option value="San Marino (+378)">San Marino (+378) </option><option value="Sao Tome and Principe (+239)">Sao Tome and Principe (+239) </option><option value="Saudi Arabia (+966)">Saudi Arabia (+966) </option><option value="Senegal (+221)">Senegal (+221) </option><option value="Seychelles (+248)">Seychelles (+248) </option><option value="Sierra Leone (+232)">Sierra Leone (+232) </option><option value="Slovak Republic (+421)">Slovak Republic (+421) </option><option value="Slovenia (+386)">Slovenia (+386) </option><option value="Solomon Islands (+677)">Solomon Islands (+677) </option><option value="Somalia (+252)">Somalia (+252) </option><option value="South Africa (+27)">South Africa (+27) </option><option value="Spain (+34)">Spain (+34) </option><option value="Sri Lanka (+94)">Sri Lanka (+94) </option><option value="St. Helena (+290)">St. Helena (+290) </option><option value="St. Pierre and Miquelon (+508)">St. Pierre and Miquelon (+508) </option><option value="Sudan (+249)">Sudan (+249) </option><option value="Suriname (+597)">Suriname (+597) </option><option value="Swaziland (+268)">Swaziland (+268) </option><option value="Sweden (+46)">Sweden (+46) </option><option value="Switzerland (+41)">Switzerland (+41) </option><option value="Syria (+963)">Syria (+963) </option><option value="Taiwan (+886)">Taiwan (+886) </option><option value="Tajikistan (+992)">Tajikistan (+992) </option><option value="Tanzania (+255)">Tanzania (+255) </option><option value="Thailand (+66)">Thailand (+66) </option><option value="Togo (+228)">Togo (+228) </option><option value="Tokelau (+690)">Tokelau (+690) </option><option value="Tonga (+676)">Tonga (+676) </option><option value="Trinidad and Tobago (+1868)">Trinidad and Tobago (+1868) </option><option value="Tunisia (+216)">Tunisia (+216) </option><option value="Turkey (+90)">Turkey (+90) </option><option value="Turkmenistan (+993)">Turkmenistan (+993) </option><option value="Turks and Caicos Islands (+1649)">Turks and Caicos Islands (+1649) </option><option value="Tuvalu (+688)">Tuvalu (+688) </option><option value="Uganda (+256)">Uganda (+256) </option><option value="Ukraine (+380)">Ukraine (+380) </option><option value="Uruguay (+598)">Uruguay (+598)  </option><option value="US Minor Outlying Islands (+581)">US Minor Outlying Islands (+581)  </option><option value="Uzbekistan (+998)">Uzbekistan (+998)  </option><option value="Vanuatu (+678)">Vanuatu (+678)  </option><option value="Vatican City State (Holy See) (+379)">Vatican City State (Holy See) (+379)  </option><option value="Venezuela (+58)">Venezuela (+58)  </option><option value="Vietnam (+84)">Vietnam (+84)  </option><option value="Virgin Islands (British) (+284">Virgin Islands (British) (+284)  </option><option value="Virgin Islands (U.S.) (+340)">Virgin Islands (U.S.) (+340)  </option><option value="Wallis and Futuna Islands (+681)">Wallis and Futuna Islands (+681)  </option><option value="Western Sahara (+212)">Western Sahara (+212)  </option><option value="Yemen (+967)">Yemen (+967)  </option><option value="Yugoslavia (+38)">Yugoslavia (+38)  </option><option value="Zambia (+260)">Zambia (+260)  </option><option value="Zimbabwe (+263) ">Zimbabwe (+263)  </option><option value="91">India (+91)  </option><option value="971">United Arab Emirates (+971)  </option><option value="81">Japan (+81)  </option><option value="United Kingdom (+44)">United Kingdom (+44)  </option><option value="Canada (+1)">Canada (+1)  </option><option value="Australia (+61">Australia (+61)  </option><option value="Germany (+49) ">Germany (+49)  </option><option value="Russian Federation (+7)">Russian Federation (+7)  </option><option value="China (+86)">China (+86)  </option><option value="Singapore (+65)">Singapore (+65)</option></optgroup></select>
                                                                                    </div>
                                             
                                                <div className="col">
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ex: 7701898761"
                                                        id="phoneNumber"
                                                        value={phoneNumber}
                                                        onChange={handlePhoneNumberChange}
                                                    />
                                                     
                                                </div>
                                            </div>
                                            {countryCodeError && <div className="text-danger">{countryCodeError}</div>}
                                            {phoneNumberError && <div className="text-danger">{phoneNumberError}</div>}
                                       
                                        </div>

                <div className="col-md-6">
                    <label className="form-label m-0 mb-1 font-16 font-500 w-100">Gender</label>
                    <div className="radio_parent row g-2">
                        <div className="col-6">
                            <div className="form-check custom-rectbox-radio">
                                <input
                                    className="form-check-input moveFunction d-none"
                                    type="radio"
                                    name="gender"
                                    id="male"
                                    value="MALE"
                                    onChange={handleGenderChange}
                                    checked={gender === 'MALE'} // Assuming gender state is properly set
                                />
                                <label className="form-check-label" htmlFor="male">
                                    <span className="fst-normal font-500 p-0">Male</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-check custom-rectbox-radio">
                                <input
                                    className="form-check-input moveFunction d-none"
                                    type="radio"
                                    name="gender"
                                    id="female"
                                    value="FEMALE"
                                    onChange={handleGenderChange}
                                    checked={gender === 'FEMALE'} // Assuming gender state is properly set
                                />
                                <label className="form-check-label" htmlFor="female">
                                    <span className="fst-normal font-500 p-0">Female</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>


                                       
                                        
                                      
                                       
                                        {genderError && <div className="text-danger">{genderError}</div>}

                                       
                                        <div className="col-md-12">
                                            <div className="action_btns mt-3">
                                                <button type="button" className="nextbtn px-4" onClick={handleSubmit}>Update & Next</button>
                                            </div>
                                        </div>
                                      
                                    </div>
                                </form>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
export default LeadInfo;